// DSC36 (DEC-343). The floor's reading of a refused bartender discount.
//
// Owner ruling 2026-10-09, verbatim: "I dont want an explanation on the
// discount as you suggest. I want it to NOT be added and a red message shows
// why it couldnt be added."
//
// The server refuses a discount that would take $0.00 off the guest (409,
// code `discount_saves_nothing`) and writes nothing. Its message is already a
// complete plain sentence ("Not added: Member13 already gives a bigger
// discount on every drink it covers."), so the floor shows it as written, in
// red, on the discount picker, which stays open so another discount can be
// picked. Pure and DOM-free so a plain node:test file can import it.

import type { ApiErrorBody } from "./api.ts";

/** The code the server answers with. Named once; main.ts and the tests share it. */
export const DISCOUNT_SAVES_NOTHING_CODE = "discount_saves_nothing";

/** Shown when the server's own sentence is missing, so the red line is never blank. */
export const DISCOUNT_SAVES_NOTHING_FALLBACK =
  "Not added: this discount would not take anything off the ticket.";

/**
 * The sentence the discount picker shows in red, or undefined when this
 * response is not that refusal (an ordinary failure keeps its toast).
 */
export function discountRefusalMessage(
  result: { status: number; body?: Partial<ApiErrorBody> | undefined },
): string | undefined {
  if (result.status !== 409 || result.body?.error !== DISCOUNT_SAVES_NOTHING_CODE) {
    return undefined;
  }
  const message = result.body.message;
  return typeof message === "string" && message.trim() !== ""
    ? message
    : DISCOUNT_SAVES_NOTHING_FALLBACK;
}
